import { useContext } from "react";

import { EditBoardConfigurationContext } from "./EditBoardConfigurationContext";

export const useEditBoardConfiguration = () => useContext(EditBoardConfigurationContext);
